/* The Charm Lab — the "Add a gift box" tick-box in the bag.

   Rendered by snippets/gift-box-option.liquid in the cart drawer and on the
   cart page. Shopify's checkout cannot take add-ons on this plan, so the box
   is offered here, as the last step before checkout. The gift box itself is
   an ordinary product (handle gift-box, type "Gift Box", hidden from search),
   so it shows as its own line in the bag, at checkout and on the order.

   Ticking adds one box; unticking removes the line. The drawer is then
   re-rendered by theme.js (window.charmLabRefreshCart); the cart page is
   server-rendered, so it simply reloads.

   This file is loaded once from layout/theme.liquid and listens on the
   document, because the drawer's markup is replaced on every refresh and a
   script inside it would never run again. */
(function () {
  'use strict';

  var busy = false;
  var root = ((window.themeRoutes && window.themeRoutes.root_url) || '/').replace(/\/?$/, '/');

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      return r.json();
    });
  }

  function after() {
    if (document.querySelector('.cart-page')) { location.reload(); return; }
    if (window.charmLabRefreshCart) return window.charmLabRefreshCart();
    location.reload();
  }

  document.addEventListener('change', function (e) {
    var box = e.target && e.target.closest ? e.target.closest('[data-giftbox]') : null;
    if (!box) return;
    if (busy) { box.checked = !box.checked; return; }
    busy = true;
    box.disabled = true;

    var req = box.checked
      ? post('cart/add.js', { items: [{ id: parseInt(box.getAttribute('data-giftbox'), 10), quantity: 1 }] })
      : post('cart/change.js', { id: box.getAttribute('data-giftbox-key'), quantity: 0 });

    req.then(after).catch(function () {
      box.checked = !box.checked;
      if (window.charmLabToast) window.charmLabToast('Could not update the gift box. Please try again.');
    }).then(function () {
      busy = false;
      box.disabled = false;
    });
  });
})();